module.exports = __webpack_public_path__ + "img/weather-sprite.2738019d.svg";